// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kit__details{flex-direction:row}@media(min-width:1499px){.kit__details{flex-direction:column;gap:0}}@media(max-width:960px){.kit__details{flex-wrap:wrap;gap:0 .75rem}}.kit__component{flex-basis:min-content;flex-grow:1;margin:-1.5rem .5rem .5rem}@media(max-width:1499px){.kit__component{margin-left:1rem;margin-top:1.5rem;width:45%}}@media(max-width:960px){.kit__component{width:100%}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
